export default [
  {
    header: 'DeFi',
  },
  {
    title: 'Overview',
    route: 'defi',
    icon: 'DollarSignIcon',
  },
  {
    title: 'Protocols',
    icon: 'ApertureIcon',
    tag: '3',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'Ref Finance',
        route: { name: 'reffinance' },
      },
      {
        title: 'Burrow',
        route: { name: 'burrow' },
      },
      {
        title: 'Meta Pool',
        route: { name: 'metapool' },
      },
    ],
  },
]
